/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { isBoolean } from "utils/lodashUtils";
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { handleConfigChange, validateConfigAndShowPanel } from "../utils/BottomBoard";
import { HIDE_PANEL_STATES } from "constants/constants";

export const getBottomBoardApis = stores => {
  function showPanel(val, overrideVisibility = false) {
    if (isBoolean(val)) {
      if (overrideVisibility) {
        val
          ? stores.bottomBoard.deleteFromHidePanelActiveStates(HIDE_PANEL_STATES.DISABLE)
          : stores.bottomBoard.addToHidePanelActiveStates(HIDE_PANEL_STATES.DISABLE);
      }

      validateConfigAndShowPanel(val, stores, shouldShow => {
        stores.bottomBoard.setPanelVisibility(shouldShow);
      });
    }
  }

  function showBanner(val) {
    if (isBoolean(val)) {
      stores.bottomBoard.setBannerVisibility(val);
    }
  }

  function setPanel(val, props) {
    stores.bottomBoard.setPanel(val, props);
  }

  function setBanner(val) {
    stores.bottomBoard.setBanner(val);
  }

  function setConfig(val = stores.bottomBoard.config) {
    stores.bottomBoard.setConfig(val);
    handleConfigChange(val, stores);
  }

  return {
    showPanel,
    setBanner,
    setPanel,
    showBanner,
    setConfig
  };
};

export const registerBottomBoardApis = stores => {
  apiFactory.registerApi(publicApiNames.BOTTOM_BOARD, clientName => getBottomBoardApis(stores), true);
};
